<template>
  <v-form v-model="isValid">
    <v-container class="py-0">
      <v-row>
        <v-col
          cols="12"
        >
          <infinity-name-field
            v-model="editedUniverse.Name"
            label="Name of the universe"
            hint="The name should be alphanumerical"
            :readonly="!editedUniverse.Editable"
          />
        </v-col>
        <v-col cols="12">
          <infinity-textarea
            color="secondary"
            label="Description"
            hint="Short summary of the universe"
            :readonly="!editedUniverse.Editable"
          />
        </v-col>
        <v-col
          v-if="editedUniverse.Editable"
          cols="12"
          class="text-right"
        >
          <v-btn
            v-if="!isNew"
            :disabled="hasApps"
            color="error"
            min-width="150"
            class="mr-4"            
            @click="remove()"
          >
            Delete
          </v-btn>
          <v-btn
            color="primary"
            min-width="150"
            @click="isNew ? create() : update()"
            v-html="isNew ? 'Create Universe' : 'Update Universe'"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'UniverseData',
    props: {
      universe: {
        type: Object,
        default: () => ({}),
      },
    },
    data: () => {
      return {
        name: '',
        isValid: false,
        editedUniverse: {},
      }
    },
    computed: {
      hasApps () {
        if (!this.editedUniverse.Apps) {
          return false
        }
        if (!this.editedUniverse.Apps.length) {
          return false
        }
        return true
      },
      isNew () {
        if (!this.universe?.Name) {
          return true
        }
        return false
      },
    },
    watch: {
      isNew (nV) {
        if (nV) {
          this.editedUniverse = {
            Name: '',
            Description: '',
            Editable: true,
          }
        } else {
          this.editedUniverse = { ...this.universe }
        }
      },
    },
    mounted () {
      this.editedUniverse = {
        Name: '',
        Description: '',
        Editable: true,
      }
    },
    methods: {
      create () {
        if (!this.isValid) {
          return
        }
        const store = this.$store
        axios
          .post('/api/universes/add', this.editedUniverse)
          .then(async response => {
            if (response.status === 201) {
              await store.dispatch('app/loadUniverses')
              this.$router.push(`/universes/get/${this.editedUniverse.Name}/`)
                .then(() => {
                  store.commit('app/feedbackMessage', `Universe ${this.name} created.`)
                  store.commit('app/feedbackColor', 'success')
                  store.commit('app/displayFeedback', true)
                })
            } else {
              store.commit('app/feedbackMessage', `Something went wrong creating Universe ${this.name}!`)
              store.commit('app/feedbackColor', 'error')
              store.commit('app/displayFeedback', true)
            }
          })
      },
      update () {
        if (!this.isValid) {
          return
        }
        axios        
          .put(`/api/universes/get/${this.editedUniverse.Name}/`, this.editedUniverse)
          .then(response => {
            if (response.status === 201) {
              this.$store.commit('app/feedbackMessage', `Universe ${this.editedUniverse.Name} updated.`)
              this.$store.commit('app/feedbackColor', 'success')
              this.$store.commit('app/displayFeedback', true)
            } else {
              this.$store.commit('app/feedbackMessage', `Something went wrong updating Universe ${this.editedUniverse.Name}!`)
              this.$store.commit('app/feedbackColor', 'error')
              this.$store.commit('app/displayFeedback', true)
            }
          })
      },
      remove () {
        if (this.hasApps) {
          return
        }
        const store = this.$store
        axios
          .delete(`/api/universes/get/${this.editedUniverse.Name}/`, this.editedUniverse)
          .then(async response => {
            if (response.status === 200) {              
              await store.dispatch('/app/loadUniverses')
              this.$router.push('/')
              this.$store.commit('app/feedbackMessage', `Universe ${this.editedUniverse.Name} deleted.`)
              this.$store.commit('app/feedbackColor', 'error')
              this.$store.commit('app/displayFeedback', true)
            } else {
              this.$store.commit('app/feedbackMessage', `Something went wrong deleting universe ${this.editedUniverse.Name}!`)
              this.$store.commit('app/feedbackColor', 'error')
              this.$store.commit('app/displayFeedback', true)              
            }
          })
      },
    },
  }
</script>
